import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Resdit7421PerformanceReport from '../../components/Resdit7421PerformanceReport';
import {
  COLUMN_ACCESSOR_CARDIT_TOTALS,
  PROPERTY_ORIGINAL_GRAND_TOTAL,
  getFilteredAndSortedData,
  getIsFiltered,
  getOriginalGrandTotal,
  getGeneratedOnDateTime,
  getIsLoading, getColumns,
} from '../redux/selectors/Resdit7421PerformanceLocationSelectors';
import Resdit7421PerformanceLocationReportMode from './Resdit7421PerformanceLocationReportMode';
import {
  getLeafColumns, getPropertyValueByPath, setPropertyValueByPath, deepClone,
} from '../../../../../react-table/helpers/utils';
import { getReportMode } from '../../../../common/redux/selectors/ReportsSelectors';
import {
  changeReportFiltering,
  changeReportMode,
  changeReportSorting,
} from '../../../../common/redux/actions/ReportsActions';

const MODE_TABS = [
  { value: Resdit7421PerformanceLocationReportMode.percentage, label: '%' },
  { value: Resdit7421PerformanceLocationReportMode.number, label: '#' },
];

class Resdit7421PerformanceLocationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillUnmount() {
    this.props.changeReportFiltering({
      reportDefinition: {
        id: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id,
      },
      sorting: {},
      filtering: {},
    });
  }

  onLocationReportSortedChange = (newSorted, column, shiftKey) => {
    this.props.changeReportSorting({
      reportDefinition: {
        id: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id,
      },
      sorting: {
        newSorted,
        column,
        shiftKey,
      },
    });
  };

  onLocationReportFilteredChange = (column, value) => {
    this.props.changeReportFiltering({
      reportDefinition: {
        id: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id,
      },
      filtering: {
        appliedFilters: column,
        appliedColumn: value,
      },
    });
  };

  getColumnsWithOriginalGrandTotal() {
    const { columns } = this.props;

    const transformedColumns = deepClone(columns);

    const leafColumns = getLeafColumns(transformedColumns);
    const columnWithGrandTotalLink = leafColumns.find(column => column.accessor === COLUMN_ACCESSOR_CARDIT_TOTALS);

    const originalGrandTotal = getPropertyValueByPath(columnWithGrandTotalLink, PROPERTY_ORIGINAL_GRAND_TOTAL);
    if (!originalGrandTotal && this.props.isFiltered && this.props.originalGrandTotal) {
      setPropertyValueByPath(columnWithGrandTotalLink, PROPERTY_ORIGINAL_GRAND_TOTAL, this.props.originalGrandTotal);
    }

    return transformedColumns;
  }

  changeMode = (reportMode) => {
    this.props.changeReportMode({
      reportDefinition: {
        id: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id,
      },
      reportMode,
    });
  };

  render() {
    return (<Resdit7421PerformanceReport
      reportId={ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id}
      columns={this.getColumnsWithOriginalGrandTotal.apply(this)}
      isLoading={this.props.isLoading}
      generatedOnDateTime={this.props.generatedDateTime}
      data={this.props.data}
      modeTabs={MODE_TABS}
      changeMode={this.changeMode}
      mode={this.props.mode}
      onSortedChange={this.onLocationReportSortedChange}
      onFilteredChange={this.onLocationReportFilteredChange}
    />);
  }
}

const mapStateToProps = state => ({
  data: getFilteredAndSortedData(state),
  generatedDateTime: getGeneratedOnDateTime(state),
  isLoading: getIsLoading(state),
  columns: getColumns(state),
  mode: getReportMode(state, ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_107B.id),
  isFiltered: getIsFiltered(state),
  originalGrandTotal: getOriginalGrandTotal.apply(this, [state]),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeReportMode,
    changeReportSorting,
    changeReportFiltering,
  }, dispatch);

Resdit7421PerformanceLocationContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
  changeReportMode: PropTypes.func,
  changeReportSorting: PropTypes.func,
  changeReportFiltering: PropTypes.func,
  mode: PropTypes.string,
  isFiltered: PropTypes.bool,
  originalGrandTotal: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(Resdit7421PerformanceLocationContainer);
